import dayjs from 'dayjs';
import { ReceiptsFilters, ReceiptsReducerState } from './types';
import { monthsMap } from 'src/viewsUtils';
import { Option } from 'src/components/Select';

export const receiptsFiltersInitialValue: ReceiptsFilters = {
  order: 'asc',
  orderBy: 'date',
  query: '',
};

export const initialState: ReceiptsReducerState = {
  filters: receiptsFiltersInitialValue,
};

const DEFAULT_BASE_DATE = '2024-02-01T00:00:00.000Z';

export const getMonthsOptions = (
  baseDate: string = DEFAULT_BASE_DATE,
): Option[] => {
  let months: Option[] = [];
  const startDate = dayjs(baseDate).utc();
  const currentDate = dayjs().utc();
  let currentMonth = startDate;

  while (
    currentMonth.isBefore(currentDate) ||
    currentMonth.isSame(currentDate, 'month')
  ) {
    const monthNameInHebrew =
      monthsMap[currentMonth.format('MMMM').toLowerCase()];

    months.push({
      label: monthNameInHebrew,
      value: currentMonth.startOf('month').toISOString(),
    });

    // Move to the next month
    currentMonth = currentMonth.add(1, 'month');
  }

  return months;
};
